import { Role } from "@Constants/types";

export function isAuth(): boolean {
  return localStorage.getItem("token") !== null;
}

export function getAuthToken(): string {
  return localStorage.getItem("token") || "";
}

export function getRefreshToken(): string {
  return localStorage.getItem("refreshToken") || "";
}

export function getAppLang(): string {
  return localStorage.getItem("appLang") || "ru";
}

export function getHeaderLogoImg(): string {
  return localStorage.getItem("headerLogoImg") || "";
}

export function getFooterLogoImg(): string {
  return localStorage.getItem("footerLogoImg") || "";
}

export function getUserId(): string {
  return localStorage.getItem("userId") || "";
}

export function getUserName(): string {
  return localStorage.getItem("userName") || "";
}

export function getClientId(): string {
  return localStorage.getItem("clientId") || "";
}

export function getCustomerId(): string {
  return localStorage.getItem("customerId") || "";
}

export function getRole(): Role {
  if (!isAuth()) {
    throw Error("Unathorized role access");
  }
  return localStorage.getItem("role") as Role;
}

export function getRoleSafe(): Role | null {
  if (!isAuth()) {
    return null;
  }
  return localStorage.getItem("role") as Role;
}

export function canCreateRequest() {
  const role = getRoleSafe();
  if (!role) return false;
  const exceptRoles = ["CustomerGuest"];
  return !exceptRoles.includes(role);
}

export function canViewUsers() {
  const role = getRoleSafe();
  if (!role) return false;
  const exceptRoles = ["CustomerGuest"];
  return !exceptRoles.includes(role);
}

export function canAddNewUser() {
  const role = getRoleSafe();
  if (!role) return false;
  const exceptRoles = [
    "CustomerGuest",
    "ClientUser",
    "ClientGuest",
    "CustomerManager",
    "CustomerEmployee",
  ];
  return !exceptRoles.includes(role);
}

// edit and delete
export function canEditEverything() {
  const role = getRoleSafe();
  if (!role) return false;
  const exceptRoles = ["CustomerGuest", "ClientGuest"];
  return !exceptRoles.includes(role);
}

function hasRole(allowedRoles: Role[]) {
  const role = getRoleSafe();
  return !!role && allowedRoles.includes(role);
}

export function canEditCustomer() {
  return hasRole(["Admin", "CustomerUser"]);
}

export function canEditUser() {
  return hasRole(["Admin", "CustomerUser"]);
}

export function canAddClientUser() {
  return hasRole(["Admin", "CustomerUser", "CustomerManager", "CustomerEmployee"]);
}

export function canDeleteCustomerUser(targetRole: Role) {
  const role = getRoleSafe();
  return role === "Admin" || (role === "CustomerUser" && targetRole !== "CustomerUser");
}

export function canEditCustomerUser(targetId: string, targetRole: Role) {
  const role = getRoleSafe();
  return (
    role === "Admin" ||
    (role === "CustomerUser" && (targetRole !== "CustomerUser" || targetId === getUserId()))
  );
}

export function canDeleteClient() {
  return hasRole(["Admin", "CustomerUser", "CustomerManager"]);
}

export function canDeleteGroup() {
  return hasRole(["Admin", "CustomerUser", "CustomerManager"]);
}

export function canDeleteRequest() {
  return hasRole(["Admin", "CustomerUser", "CustomerManager"]);
}

export function canAddAbility() {
  const role = getRoleSafe();
  if (!role) return false;
  const exceptRoles = ["CustomerGuest"];
  return !exceptRoles.includes(role);
}
